import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

export type Response = {
  ok: string,
  data: string
}
const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 250);

export async function createObservations(entityId, observationsData, entityType) {
  const url = `${API_URL}/observations/${entityId}`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ observationsData, entityType }),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<Response>>;

  return result;
}